import { render, staticRenderFns } from "./BillsTable.vue?vue&type=template&id=3c59c210"
import script from "./BillsTable.vue?vue&type=script&setup=true&lang=js"
export * from "./BillsTable.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports